<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd"
          @click="$router.push('/inspectionPoint/add?pointType=' + pointType)">新增</el-button>
      </template>
      <el-form inline ref="searchForm" class="global-form-label-width">

        <el-form-item prop="pointName" label="点位名称">
          <el-input clearable v-model="searchForm.pointName" placeholder="请输入点位名称" />

        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="100" label="点位ID" prop="pointId"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="100" label="点位名称" prop="pointName"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="所在位置" prop="location">

        </el-table-column>
        <!-- <el-table-column show-overflow-tooltip min-width="140" label="检查项" prop="itemLis">
          <template v-slot="{ row }">
            {{ row.itemLis &&row.itemLis.length>0?row.itemLis.join(';'):'-' }}
          </template>

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="创建人" prop="createUserName"></el-table-column> -->
        <el-table-column show-overflow-tooltip min-width="120" label="创建时间" prop="ctime"></el-table-column>

        <el-table-column fixed="right" label="操作" width="220">
          <template v-slot="{ row }">
            <el-button type="text" @click="showQrcode(row.pointQr)">查看二维码</el-button>
            <el-button type="text"
              @click="$router.push('/inspectionPoint/detail?pointId=' + row.pointId + '&pointType=' + pointType)">详情</el-button>
            <el-button type="text" v-if="hasEdit"
              @click="$router.push('/inspectionPoint/edit?pointId=' + row.pointId + '&pointType=' + pointType)">编辑</el-button>
            <el-button type="text" v-if="hasDel" @click="deleteRow(row.pointId)" class="del-btn">删除</el-button>

          </template>
        </el-table-column>
      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>

      <el-dialog title="二维码" :visible.sync="dialogVisible" width="400px">
        <el-image style="width: 100%; height: 100%" :src="qrCodeImg" fit="cover" />
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'inspectionPoint',
  mixins: [keepAlive],
  data() {
    return {
      dialogVisible: false,
      qrCodeImg: '',
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        pointName: null
      }

    }
  },
  computed: {
    pointType() {
      return this.$route.query.pointType // 点位类型1品控2安环  3储运
    },
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  watch: {
    '$route.query'(newV) {
      console.log('充值了')
      this.resetForm()
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    showQrcode(pointQr) {
      this.qrCodeImg = pointQr
      this.dialogVisible = true
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.inspectionPoint.selectPaInspectPointByPage, {
        params: {
          page: this.page,
          ...this.searchForm,
          pointType: this.pointType
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },

    onSearch() {
      this.page = 1
      this.loadData()
    },
    resetForm() {
      this.$refs.searchForm.resetFields()
      this.searchForm = {
        pointName: null
      }
      this.onSearch()
    },
    deleteRow(pointId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.inspectionPoint.deletePaInspectPoint, {
          pointId
        }).then(() => {
          this.loadData()
        })
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
